import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';

import { ProductsListPage } from './ProductsListPage';

export function ProductsPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<ProductsListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

ProductsPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
